"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.removeCashBalancesFeedContextArtifacts = exports.createGeneratedCashToBorrowingBaseDependenciesForDetach = exports.addCashBalancesFeedContextArtifacts = exports.createCashBalancesFeedContext = void 0;
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const helpers_1 = require("./helpers");
const createCashBalancesFeedContext = (manualBankAccountReport) => {
    (0, common_1.finleyAssert)(manualBankAccountReport.creditFacilitySlug, 'creditFacilitySlug of manualBankAccountReport type must be defined');
    return {
        id: (0, uuid_1.v4)(),
        type: 'cashBalancesFeedContext',
        configuration: {},
        loanProductSlug: null,
        creditFacilitySlug: manualBankAccountReport.creditFacilitySlug,
        artifactDocumentId: manualBankAccountReport.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `cashBalancesFeedContext_${manualBankAccountReport.creditFacilitySlug}`, // uniq for cashBalancesFeedContext
    };
};
exports.createCashBalancesFeedContext = createCashBalancesFeedContext;
/**
 * Runs after the manualBankAccountReport step. Drops each
 * "manualBankAccountReport -> report" edge and attaches a synthetic
 * "cashBalancesFeedContext" as the report's cash input (borrowingBaseReport or
 * directInsertBorrowingBaseReport). The manualBankAccountReport ->
 * cashBalancesFeedContext input edge is intentionally NOT added here — the
 * bank-report lambda later produces the cash feed as a leaf node.
 *
 *                        *** Current ***
 * +-------------------------+      +---------------------+
 * | manualBankAccountReport | ---> | borrowingBaseReport |
 * +-------------------------+      +---------------------+
 *
 *                        *** Revised ***  (manualBankAccountReport -> report edge is dropped)
 * +-------------------------+       +---------------------+
 * | manualBankAccountReport |       | borrowingBaseReport |
 * +-------------------------+       +---------------------+
 *                                              ^
 * +-------------------------+                  |
 * | cashBalancesFeedContext | -----------------+
 * +-------------------------+
 */
const addCashBalancesFeedContextArtifacts = (graph) => {
    const dataTapeDependencies = (0, lodash_1.cloneDeep)(graph.dataTapeDependencies);
    const dataTapes = (0, lodash_1.cloneDeep)(graph.dataTapes);
    const manualBankAccountReports = utils.filterManualBankAccountReports({
        dataTapes,
    });
    const borrowingBaseReports = utils.filterBorrowingBaseReports({ dataTapes });
    const directInsertBorrowingBaseReports = utils.filterDirectInsertBorrowingBaseReports({ dataTapes });
    const borrowingBaseReportIds = [];
    borrowingBaseReports.forEach(({ id }) => borrowingBaseReportIds.push(id));
    directInsertBorrowingBaseReports.forEach(({ id }) => borrowingBaseReportIds.push(id));
    manualBankAccountReports.forEach((manualBankAccountReport) => {
        const cashBalancesFeedContext = (0, exports.createCashBalancesFeedContext)(manualBankAccountReport);
        // remove edge from ManualBankAccountReport => BorrowingBaseReport
        const removedDependencies = (0, lodash_1.remove)(dataTapeDependencies, (dep) => borrowingBaseReportIds.includes(dep.outputArtifactId) &&
            dep.inputArtifactId === manualBankAccountReport.id);
        removedDependencies.forEach((dep) => {
            const { outputDependency } = utils.insertDependency({
                dataTapeDependency: dep,
                insertId: cashBalancesFeedContext.id,
            });
            dataTapeDependencies.push(outputDependency);
        });
        // we don't want to add inputDependency here (manualBankAccountReport => cashBalancesFeedContext)
        // as bank report lambda will create leaf node cashBalanceFeed once all required
        // cash balances have been uploaded.
        dataTapes.push(cashBalancesFeedContext);
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addCashBalancesFeedContextArtifacts = addCashBalancesFeedContextArtifacts;
/**
 * Reconstruct the UI cash-feed links from facility/configuration metadata.
 * Direct-insert reports take precedence over the facility's regular report.
 * Use the original DB nodes because the report process clears this metadata
 * before the cash processes are detached.
 */
const createGeneratedCashToBorrowingBaseDependenciesForDetach = (params) => {
    const { dataTapes } = params;
    // Fetch "generatedCashBalanceFeeds" as these are the target artifacts
    const generatedCashBalanceFeeds = utils.filterGeneratedCashBalanceFeeds({
        dataTapes,
    });
    // Fetch "borrowingBaseReports" (and direct) as these are potential outputs
    const borrowingBaseReports = utils.filterBorrowingBaseReports({ dataTapes });
    const directInsertBorrowingBaseReports = utils.filterDirectInsertBorrowingBaseReports({ dataTapes });
    const dependencies = generatedCashBalanceFeeds.map((generatedCashBalanceFeed) => {
        const { creditFacilitySlug, artifactSlug } = generatedCashBalanceFeed;
        (0, common_1.finleyAssert)(creditFacilitySlug, `creditFacilitySlug must exist on generatedCashBalanceFeed [artifactSlug:${artifactSlug}]`);
        // First check if the generated cash balance feed was referenced by a
        // "directInsertBorrowingBaseReport" node. If so, then prioritize re-linking
        // the cash balance feed node to this.
        const targetDirectInsertBorrowingBaseReports = directInsertBorrowingBaseReports.filter((node) => node.creditFacilitySlug === creditFacilitySlug &&
            node.configuration.generatedCashBalanceFeedArtifactSlug ===
                artifactSlug);
        if (targetDirectInsertBorrowingBaseReports.length) {
            return targetDirectInsertBorrowingBaseReports.map((targetDirectInsertBorrowingBaseReport) => ({
                outputArtifactId: targetDirectInsertBorrowingBaseReport.id,
                inputArtifactId: generatedCashBalanceFeed.id,
            }));
        }
        // If no "directInsertBorrowingBaseReport" is pointing to this, then default
        // back to assuming single borrowing base report for credit facility.
        const filteredBorrowingBaseReports = borrowingBaseReports.filter((report) => report.creditFacilitySlug === creditFacilitySlug);
        (0, common_1.finleyAssert)(filteredBorrowingBaseReports.length === 1, `unable to find single borrowing base report with creditFacilitySlug ${creditFacilitySlug}`);
        const borrowingBaseReport = filteredBorrowingBaseReports[0];
        return [
            {
                outputArtifactId: borrowingBaseReport.id,
                inputArtifactId: generatedCashBalanceFeed.id,
            },
        ];
    });
    return dependencies.flat();
};
exports.createGeneratedCashToBorrowingBaseDependenciesForDetach = createGeneratedCashToBorrowingBaseDependenciesForDetach;
/**
 * Inverse of {@link addCashBalancesFeedContextArtifacts}: drops the synthetic
 * cashBalancesFeedContext and rebuilds the "manualBankAccountReport -> report"
 * edges from the original facility metadata (via
 * {@link createGeneratedCashToBorrowingBaseDependenciesForDetach}, with
 * direct-insert precedence). Uses `sourceGraph` because the report step clears
 * that metadata before the cash processes are detached.
 *
 *                        *** Current ***
 * +-------------------------+       +---------------------+
 * | manualBankAccountReport |       | borrowingBaseReport |
 * +-------------------------+       +---------------------+
 *                                              ^
 * +-------------------------+                  |
 * | cashBalancesFeedContext | -----------------+
 * +-------------------------+
 *
 *                        *** Revised ***
 * +-------------------------+      +---------------------+
 * | manualBankAccountReport | ---> | borrowingBaseReport |
 * +-------------------------+      +---------------------+
 */
const removeCashBalancesFeedContextArtifacts = (graph, { sourceGraph }) => {
    const manualReports = utils.filterManualBankAccountReports(graph);
    const restored = (0, exports.createGeneratedCashToBorrowingBaseDependenciesForDetach)({
        dataTapes: sourceGraph.dataTapes,
    }).map((dependency) => {
        const feed = utils.findArtifactById({
            dataTapes: sourceGraph.dataTapes,
            artifactId: dependency.inputArtifactId,
        });
        const report = manualReports.find((tape) => tape.creditFacilitySlug === feed.creditFacilitySlug);
        (0, common_1.finleyAssert)(report, `Manual bank account report must exist for ${feed.artifactSlug}`);
        return {
            inputArtifactId: report.id,
            outputArtifactId: dependency.outputArtifactId,
        };
    });
    const { dataTapes, dataTapeDependencies } = (0, helpers_1.removeNodesAndIncidentEdges)(graph, utils.filterCashBalancesFeedContexts(graph).map(({ id }) => id));
    return {
        dataTapes,
        dataTapeDependencies: [...dataTapeDependencies, ...restored],
    };
};
exports.removeCashBalancesFeedContextArtifacts = removeCashBalancesFeedContextArtifacts;
exports.syntheticProcess = {
    toDb: exports.addCashBalancesFeedContextArtifacts,
    fromDb: exports.removeCashBalancesFeedContextArtifacts,
};
//# sourceMappingURL=cashBalancesFeedContext.js.map